// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/FullPagePopup.css */

.full-page-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0; /* Start with hidden popup */
  pointer-events: none; /* Prevent interaction while hidden */
  transition: opacity 0.3s ease-in-out;
}

.full-page-popup.active {
  opacity: 1; /* Fade in when active */
  pointer-events: auto; /* Allow interaction when visible */
}

.popup-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover; /* Background image will now be set dynamically */
  background-position: center center;
  z-index: 9998; /* Lower than popup-content but higher than underlying page */
  filter: blur(2px); /* Initial blur effect */
  opacity: 0;
  transition: opacity 0.5s ease, filter 0.5s ease; /* Smooth transition for blur and opacity */
}

.popup-background.loaded {
  opacity: 1;
  filter: blur(0px); /* Remove blur after the background is loaded */
}

.popup-content {
  position: relative;
  z-index: 9999; /* Ensure content is above the background */
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 600px;
  margin: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 0.85;
  max-height: 90%;
  overflow-y: auto;
  transition: opacity 0.5s ease-in-out;
}

.close {
  position: absolute;
  top: 6px;
  right: 12px;
  font-size: 1.5rem; 
  cursor: pointer;
}

.tab-content {
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
}

@media (min-width: 768px) {
  .popup-content {
    padding: 40px;
    max-width: 700px;
  }
}

@media (min-width: 992px) {
  .popup-content {
    padding: 50px;
    max-width: 800px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/FullPagePopup.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU,EAAE,4BAA4B;EACxC,oBAAoB,EAAE,qCAAqC;EAC3D,oCAAoC;AACtC;;AAEA;EACE,UAAU,EAAE,wBAAwB;EACpC,oBAAoB,EAAE,mCAAmC;AAC3D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB,EAAE,iDAAiD;EACzE,kCAAkC;EAClC,aAAa,EAAE,6DAA6D;EAC5E,iBAAiB,EAAE,wBAAwB;EAC3C,UAAU;EACV,+CAA+C,EAAE,2CAA2C;AAC9F;;AAEA;EACE,UAAU;EACV,iBAAiB,EAAE,+CAA+C;AACpE;;AAEA;EACE,kBAAkB;EAClB,aAAa,EAAE,2CAA2C;EAC1D,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":["/* src/components/FullPagePopup.css */\r\n\r\n.full-page-popup {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1050;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  opacity: 0; /* Start with hidden popup */\r\n  pointer-events: none; /* Prevent interaction while hidden */\r\n  transition: opacity 0.3s ease-in-out;\r\n}\r\n\r\n.full-page-popup.active {\r\n  opacity: 1; /* Fade in when active */\r\n  pointer-events: auto; /* Allow interaction when visible */\r\n}\r\n\r\n.popup-background {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-size: cover; /* Background image will now be set dynamically */\r\n  background-position: center center;\r\n  z-index: 9998; /* Lower than popup-content but higher than underlying page */\r\n  filter: blur(2px); /* Initial blur effect */\r\n  opacity: 0;\r\n  transition: opacity 0.5s ease, filter 0.5s ease; /* Smooth transition for blur and opacity */\r\n}\r\n\r\n.popup-background.loaded {\r\n  opacity: 1;\r\n  filter: blur(0px); /* Remove blur after the background is loaded */\r\n}\r\n\r\n.popup-content {\r\n  position: relative;\r\n  z-index: 9999; /* Ensure content is above the background */\r\n  background-color: rgba(255, 255, 255, 0.9);\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  width: 90%;\r\n  max-width: 600px;\r\n  margin: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  opacity: 0.85;\r\n  max-height: 90%;\r\n  overflow-y: auto;\r\n  transition: opacity 0.5s ease-in-out;\r\n}\r\n\r\n.close {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 12px;\r\n  font-size: 1.5rem; \r\n  cursor: pointer;\r\n}\r\n\r\n.tab-content {\r\n  width: 100%;\r\n  max-height: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .popup-content {\r\n    padding: 40px;\r\n    max-width: 700px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .popup-content {\r\n    padding: 50px;\r\n    max-width: 800px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
